import { create } from 'zustand'
import { devtools, persist, createJSONStorage } from 'zustand/middleware'
import type { HotelAvailabilityParams } from '~/hooks/type'
import type { RoomAvailabilitySearch, RoomPriceGroup, MappedPrices } from '~/types/hotel'
import type { RoomAvailability } from '~/hooks/type'

interface HotelAvailabilityState {
  availability: RoomAvailability[]
  availabilitySearch: RoomAvailabilitySearch[]
  groupedPrices: RoomPriceGroup[]
  mappedPrices: MappedPrices
  searchParams: HotelAvailabilityParams | null
  isLoading: boolean
  isError: boolean | null
  setAvailability: (data: RoomAvailability[]) => void
  setLoading: (loading: boolean) => void
  setError: (error: boolean) => void
  reset: () => void
}

export const useHotelAvailabilityStore = create<HotelAvailabilityState>()(
  devtools(
    persist(
      (set) => ({
        availability: [],
        availabilitySearch: [],
        groupedPrices: [],
        mappedPrices: {},
        searchParams: null,
        isLoading: false,
        isError: null,

        setAvailability: (data) => set({ availability: data }),
        setLoading: (loading) => set({ isLoading: loading }),
        setError: (error) => set({ isError: error }),
        reset: () =>
          set({
            availability: [],
            availabilitySearch: [],
            groupedPrices: [],
            mappedPrices: {},
            searchParams: null,
            isLoading: false,
            isError: null,
          }),
      }),
      {
        name: 'hotel-availability-storage',
        storage: createJSONStorage(() => sessionStorage),
        partialize: (state) => ({
          availability: state.availability,
        }),
      }
    )
  )
)
